import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { DaterangeService } from 'src/core/services/daterange.service';
import { DeviceService } from 'src/core/services/device.service';
import { LoadingService } from 'src/core/services/loading.service';
import { ModalService } from 'src/core/services/modal.service';
import { SelectedSiteService } from 'src/core/services/selectedsite.service';
import { SelectedsystemService } from 'src/core/services/selectedsystem.service';
import { WidgetService } from 'src/core/services/widget.service';
import { ServiceHistoryOverview, ServiceHistoryOverviewSite } from 'src/core/types/servicehistory.types';

@Component({
  selector: 'app-service-history',
  imports: [CommonModule, TranslocoModule],
  templateUrl: './service-history.component.html',
  styleUrl: './service-history.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ServiceHistoryComponent {

  @Input() type: 'device' | 'site' = 'device';

  constructor(
    private loadingService: LoadingService,
    private selectedSystemService: SelectedsystemService,
    private widgetService: WidgetService,
    private daterangeService: DaterangeService,
    private modalService: ModalService,
    private deviceService: DeviceService,
    private selectedSiteService: SelectedSiteService
  ) { }

  mode: string = "overview";
  isLoading: boolean;
  isError: boolean;
  isEmpty: boolean;
  servicehistory: ServiceHistoryOverview | ServiceHistoryOverviewSite;
  expandWidget: void;
  getDeviceType = this.deviceService.getDeviceType;

  selectedRange;



  ngOnInit(): void {

    if (this.type === 'device') {

      this.loadingService.$isServiceHistoryLoading.subscribe((isSystemLoading) => {
        this.isLoading = isSystemLoading;
      });
      this.loadingService.$isServiceHistoryError.subscribe((isError) => {
        this.isError = isError;
      });
      this.loadingService.$isServiceHistoryEmpty.subscribe((isEmpty) => {
        this.isEmpty = isEmpty;
      });
      this.daterangeService.$selectedRangeServiceHistory.subscribe((selectedRange) => {
        this.selectedRange = selectedRange === 365 ? 120 : selectedRange;
      });
      this.selectedSystemService.$servicehistory.subscribe((servicehistory) => {
        this.servicehistory = servicehistory;
      });

    }

    if (this.type === 'site') {

      this.loadingService.$isServiceHistoryLoadingSite.subscribe((isSystemLoading) => {
        this.isLoading = isSystemLoading;
      });
      this.loadingService.$isServiceHistoryErrorSite.subscribe((isError) => {
        this.isError = isError;
      });
      this.loadingService.$isServiceHistoryEmptySite.subscribe((isEmpty) => {
        this.isEmpty = isEmpty;
      });
      this.daterangeService.$selectedRangeServiceHistory.subscribe((selectedRange) => {
        this.selectedRange = selectedRange === 365 ? 120 : selectedRange;
      });
      this.selectedSiteService.$servicehistory.subscribe((servicehistory) => {
        this.servicehistory = servicehistory;
      });

    }

  }

  onMaximize(filter?: string) {
    if (this.widgetService.$workareaSize.value !== "small" && this.widgetService.$selectedWidget.value === "service-history" && !filter) {
      this.widgetService.closeWidget();
      return;
    }

    if (!filter) {
      this.widgetService.expandWidget("service-history", "Notifications");
      return;
    }

    this.widgetService.expandWidget("service-history", filter);
  }

  checkWidgetIcon() {
    if (this.widgetService.$workareaSize.value !== "small" && this.widgetService.$selectedWidget.value === "service-history") {
      return "minus";
    } else {
      return "plus";
    }
  }

  changeRange(range) {
    this.daterangeService.$selectedRangeServiceHistory.next(range);
  }

  openHelp(section) {
    this.modalService.$helpModalChanged.next({ modal: section, open: true });
  }

}
